/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Box, Col, Dialog, Divider, Flex, Row, Typography } from "../../../ppui";

import useAPIHandler from "../../../hook/use-api-handler";
import { theme } from "../../../theme";
import { formatIndianCurrency, formatNumberToFixed, parseNumericValue } from "../../../utils/common";
// import { logger } from "../../../utils/logger";
import { PTAX_API } from "../../statutory/ptax/ptax-constant";
import { SALARY_KNOWN_CTC } from "./pay-benefit-const";
import { calculateEmployerContributionEPF, calculateEmployerContributionEsi } from "./pay-benefit-utils";

const SalaryDetailsView = ({ serviceProps }) => {
  const {
    allowanceList = [],
    setSalaryBreakdown,
    salaryBreakdown,
    employeePayBenefits,
    handleSubmitPayBenefitFn,
    performanceAmount,
    allowanceInfo,
    otherAllowanceCalculation,
    employeeEPFInfo,
    setAddedepf13,
    setUseractionbutton,
    useractionbutton,
    setAddedEsi,
  } = serviceProps || {};

  const { fetchData } = useAPIHandler();

  const [pTaxInfo, setPTaxInfo] = useState({});
  function getPatxFn() {
    const URL = PTAX_API.PTAX_LIST.URL;
    const METHOD = PTAX_API.PTAX_LIST.METHOD;

    const payload1 = {
      url: URL,
      METHOD,
    };
    const payload2 = PTAX_API.ORGANIZATION_PTAX_GET;

    fetchData(payload1).then((res) => {
      const ptaxYearsList = [];
      res?.data?.forEach((element) => {
        const yearRange = `${element?.year}-${element?.to_year}`;
        if (!ptaxYearsList.includes(yearRange)) {
          ptaxYearsList.push(yearRange);
        }
      });
    });

    Promise.all([fetchData(payload1), fetchData(payload2)])
      .then(([res1, res2]) => {
        const findPtaxInfo = res1?.data?.find(
          (it) => it?.ptax_id === res2?.data?.financial_year
        );
        if (res2?.data?.status) {
          setPTaxInfo(findPtaxInfo);
        }
      })
      .catch((error) => {});
  }

  useEffect(() => {
    getPatxFn();
  }, []);

  const hasEmployerContibutionIncludeInCTC = (
    employeeEPFInfo?.organizationStatutoryData?.epfOrganizationMaster || []
  )?.includes(1);
  // logger.log(JSON.stringify(employeeEPFInfo?.organizationEsicData, null, 2)+"pps");



  // const basicAndCheckedAllowanceSum = employeePayBenefits?.basic_salary  + allowanceList
  // .filter((it) => it?.isChecked && it?.addToGross)  // Filter only checked allowances with addToGross true
  // .reduce((sum, it) => {
  //   return sum + (it?.allowanceType === "percentage"
  //     ? parseNumericValue(employeePayBenefits?.basic_salary) * (parseNumericValue(it?.allowanceValue) / 100)
  //     : parseNumericValue(it?.allowanceValue));
  // }, 0);

  let basicAndCheckedAllowanceSum = employeePayBenefits?.basic_salary + allowanceInfo?.checkedAllowancesSum;
  let grossAmount = employeePayBenefits?.basic_salary + allowanceInfo?.grossIncludedCheckedAllowanceSum;
  let ctcAmount = employeePayBenefits?.basic_salary + allowanceInfo?.checkedAllowancesSum;

  if (employeePayBenefits?.salary_known === SALARY_KNOWN_CTC) {
    grossAmount = employeePayBenefits?.basic_salary + allowanceInfo?.grossIncludedCheckedAllowanceSum + performanceAmount;
    basicAndCheckedAllowanceSum = employeePayBenefits?.basic_salary + allowanceInfo?.checkedAllowancesSum + performanceAmount;
    ctcAmount = employeePayBenefits?.basic_salary + allowanceInfo?.checkedAllowancesSum + performanceAmount;
}
  const contribution15K = employeeEPFInfo?.employeeStatutoryData?.employee_contribution === "restrict_contribution";
  const isEpfEgiliable = employeeEPFInfo?.employeeStatutoryData?.epf_availability;
  let  PF_WAGES = allowanceInfo?.epfCoveredAllowancesSum + employeePayBenefits?.basic_salary;
  let totalESIWagesAmount = employeePayBenefits?.basic_salary + allowanceInfo?.esiCoveredAllowancesSum;
  const isPerformanceESICoverd = otherAllowanceCalculation?.isEsiWages;
  const isPerformanceEPFCoverd = otherAllowanceCalculation?.isEpfWages;
  
  const epfEsiEligibalePercentage = employeeEPFInfo?.organizationStatutoryData?.epfOrganizationStatus
  const isIncludeAdminCharge = employeeEPFInfo?.organizationStatutoryData?.epfOrganizationMaster?.includes(2);
  const isIncludeESICharge = employeeEPFInfo?.organizationEsicData?.is_including_employee_ctc;
  const rate = epfEsiEligibalePercentage ==="12%" ? 12:10;

  // logger.log(PF_WAGES+"pps1")
  if (isPerformanceEPFCoverd) {
      PF_WAGES =
      employeePayBenefits?.basic_salary +
      performanceAmount +
      allowanceInfo?.epfCoveredAllowancesSum;
  }
  if (isPerformanceESICoverd) {
    totalESIWagesAmount =
      employeePayBenefits?.basic_salary +
      performanceAmount +
      allowanceInfo?.esiCoveredAllowancesSum;
  }

  let ptaxAmount = 0;

  (pTaxInfo?.tax_cal || [])?.find((it) => {
    if(it?.max_salary && it?.min_salary){
      if( parseNumericValue(grossAmount) >= parseNumericValue(it?.min_salary) && parseNumericValue(grossAmount) <= parseNumericValue(it?.max_salary) ){
        ptaxAmount = parseNumericValue(it?.tax_amount);
      }
    }else{
      if( parseNumericValue(grossAmount) >= parseNumericValue(it?.min_salary) ){
        ptaxAmount = parseNumericValue(it?.tax_amount);
      }
    }
  });

  const esiElibiable = employeeEPFInfo?.employeeStatutoryData?.esi_availability;
  let esiAmount = 0;
  let eeEsiAmount = 0;
  const EsiLimit = 21000;
  if (totalESIWagesAmount <= EsiLimit && esiElibiable) {
    // esiAmount = totalESIWagesAmount * (0.75 / 100).toLocaleString(2);
    // eeEsiAmount =totalESIWagesAmount * (3.25 / 100).toLocaleString(2);
    esiAmount = Math.ceil(totalESIWagesAmount * (0.75 / 100));
    eeEsiAmount = Math.ceil(totalESIWagesAmount * (3.25 / 100));
  }
  const employerContributionESI =
  calculateEmployerContributionEsi({
    esiElibiable,
    totalESIWagesAmount,
  });

useEffect(() => {
  setAddedEsi(employerContributionESI);
}, [employerContributionESI]);

  const employerContributionEPF13PercentageShow =
    calculateEmployerContributionEPF({
      isEpfEgiliable,
      PF_WAGES,
      contribution15K,
      epfEsiEligibalePercentage,
      isIncludeAdminCharge,
      
    });

  useEffect(() => {
    setAddedepf13(employerContributionEPF13PercentageShow);
  }, [employerContributionEPF13PercentageShow]);



  const employerContributionEPF12PercentageShow =
    calculateEmployerContributionEPF({
      isEpfEgiliable,
      PF_WAGES,
      contribution15K,
      epfEsiEligibalePercentage,
    });

  const totalDeduction =
    ptaxAmount + esiAmount + employerContributionEPF12PercentageShow;

  return (
    <Dialog
      title="Salary Breakdown Calculation"
      closeButton={true}
      fullWidth
      maxWidth="lg"
      open={salaryBreakdown}
      onClose={() => {setSalaryBreakdown(false);setUseractionbutton(false)}}
      onSubmit={handleSubmitPayBenefitFn}
      separator
      bodyScroll={true}
      action={!useractionbutton}
      buttonName={"Procced"}
    >
      <Row>
        <Col>
          <Typography variant="body1" color="primary" fontWeight={500}>
            Salary Structure Information
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            CTC Salary = ₹{" "}
            {Math.round(
              employeePayBenefits?.salary_type === "wages" || employeePayBenefits?.salary_known === 'basic_salary'
                ? hasEmployerContibutionIncludeInCTC
                  ? (isIncludeESICharge && esiElibiable && totalESIWagesAmount <= EsiLimit)
                    ? parseNumericValue(ctcAmount) + parseNumericValue(employerContributionEPF13PercentageShow) + parseNumericValue(employerContributionESI)
                    : parseNumericValue(ctcAmount) + parseNumericValue(employerContributionEPF13PercentageShow)
                  : parseNumericValue(ctcAmount)
                : parseNumericValue(employeePayBenefits?.ctc_salary)
            ).toLocaleString()}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            {" "}
            Professional Tax  = ₹{formatNumberToFixed(ptaxAmount)}
          </Typography>
          <Divider gap={20}/>
          {isEpfEgiliable ? (
            <>
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              EPF Total Wages =
              {" "}
              {PF_WAGES}
            </Typography>

            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              EPF Contribution =
              {" "}
              {employeeEPFInfo?.employeeStatutoryData?.employee_contribution ===
              "restrict_contribution"
                ? "Wage limit ₹15,000 (Restrict Contribution) "
                : " Above wage limit"}

            </Typography>
            {}
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              Employee EPFContribution  {rate}% =
              {" "}
              ₹{formatNumberToFixed(
                parseNumericValue(employerContributionEPF12PercentageShow)
              )}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              Employer EPF Contribution  {isIncludeAdminCharge ? rate+1:rate}% =
              {" "}
              ₹{formatNumberToFixed(
                parseNumericValue(employerContributionEPF13PercentageShow) 
              )}

            </Typography>

            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              Employer EPF Contribution Is{" "}
              {!hasEmployerContibutionIncludeInCTC && "Not "} Included In
              CTC.
            </Typography>
            </>
          ):(
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              The Employee Provident Fund (EPF) scheme is not activated 
            </Typography>
          )}
          <Divider gap={20}/>

          {esiElibiable ? (
            <>
              <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              ESI Total Wages =
              {" "}
              {totalESIWagesAmount}
            </Typography>

              <Typography
                variant="body2"
                color="primary"
                colorVariant="light"
                fontWeight={500}
              >
                {" "}
                Employee Contribution ESI 0.75% ={" "}
                ₹{formatIndianCurrency(parseNumericValue(esiAmount))}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                colorVariant="light"
                fontWeight={500}
              >
                Employer ESI Contribution  3.25% ={" "}
                ₹{formatNumberToFixed(
                  parseNumericValue(eeEsiAmount) 
                )}

              </Typography>
              <Typography
                variant="body2"
                color="primary"
                colorVariant="light"
                fontWeight={500}
              >
                Employer ESI Contribution Is{" "}
                {!isIncludeESICharge && "Not "} Included In
                CTC.
              </Typography>
            </>

          ):(
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              {`Employee's State Insurance (ESI) scheme is not activated `}
            </Typography>
          )}
        </Col>

        <Col md={"auto"}>
          <Divider vertical/>
        </Col>
        <Col>
          <Typography variant="body1" color="primary" fontWeight={500}>
            Salary Breakdown{" "}
          </Typography>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2">
              Basic Salary{" "}
              {employeePayBenefits?.salary_known === SALARY_KNOWN_CTC &&
                ` (${employeePayBenefits?.basic_percentage}% of CTC Salary)`}
            </Typography>
            <Typography variant="body2">
              ₹{" "}
              {formatNumberToFixed(
                parseNumericValue(employeePayBenefits?.basic_salary)
              )}
            </Typography>
          </Flex>
          {allowanceList.map((it, index) => {
            if (!it?.isChecked || !it?.addToGross) {
              return null;
            }

            return (
              <Flex justifyContent="space-between" gap={10} key={index}>
                <Typography variant="body2">{it.allowanceName}</Typography>
                <Typography variant="body2">
                  ₹{" "}
                  {it?.allowanceType === "percentage"
                    ? formatNumberToFixed(
                        parseNumericValue(employeePayBenefits?.basic_salary) *
                          (parseNumericValue(it?.allowanceValue) / 100)
                      )
                    : it?.allowanceValue}
                </Typography>
              </Flex>
            );
          })}

          {employeePayBenefits?.salary_known === SALARY_KNOWN_CTC &&
            formatNumberToFixed(parseNumericValue(performanceAmount)) > 0 && (
              <Flex justifyContent="space-between" gap={10}>
                <Typography variant="body2">
                  {serviceProps?.otherAllowanceCalculation?.allowanceName}
                </Typography>
                <Typography variant="body2">
                  ₹ {formatNumberToFixed(parseNumericValue(performanceAmount))}
                </Typography>
              </Flex>
            )}
          <Divider gap={15} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} >
              Gross Amount{" "}
            </Typography>
            <Typography variant="body2" color="primary" fontWeight={500}>
              ₹ {formatNumberToFixed(parseNumericValue(grossAmount)).toLocaleString()}
            </Typography>
          </Flex>
          {allowanceList.map((it, index) => {
          if (!it?.isChecked || it?.addToGross) {
            return null;
          }

          return (
            <Flex justifyContent="space-between" gap={10} key={index}>
              <Typography variant="body2">{it.allowanceName}</Typography>
              <Typography variant="body2">
                ₹{" "}
                {it?.allowanceType === "percentage"
                  ? formatNumberToFixed(
                      parseNumericValue(employeePayBenefits?.basic_salary) *
                        (parseNumericValue(it?.allowanceValue) / 100)
                    )
                  : it?.allowanceValue}
              </Typography>
            </Flex>
          );
        })}
          <Divider gap={15} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} >
              Total Earning{" "}
            </Typography>
            <Typography variant="body2" color="primary" fontWeight={500}>
              ₹ {formatNumberToFixed(parseNumericValue(basicAndCheckedAllowanceSum)).toLocaleString()}
            </Typography>
          </Flex>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
            Total Deduction{" "}
            </Typography>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
              ₹ {formatNumberToFixed(parseNumericValue(totalDeduction)).toLocaleString()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
            Net Payble{" "}
            </Typography>
            <Box>
            <Typography variant="body2" color="primary" align="right" fontWeight={500} mb="0">
              ₹ {formatNumberToFixed(parseNumericValue(basicAndCheckedAllowanceSum) - parseNumericValue(totalDeduction)).toLocaleString()}
            </Typography>
            {/* <Typography variant="body2"  align="right"  color="default" colorVariant="light" mb="0">
              (Round off: ₹ {Math.round(Number(formatNumberToFixed(
                parseNumericValue(grossAmount) - parseNumericValue(totalDeduction)
              ))).toLocaleString()})
            </Typography> */}
            </Box>
          </Flex>
        </Col>
      </Row>  
      <Box
        
      >
        
        {/* {totalESIWagesAmount > EsiLimit} */}
       
        {/* <Typography
          variant="body2"
          color="primary"
          colorVariant="light"
          fontWeight={500}
        >
          Basic Salary ={" "}
          {employeePayBenefits?.salary_known === SALARY_KNOWN_CTC &&
            ` (${employeePayBenefits?.basic_percentage}% of CTC)`}{"  "}
          ₹{formatNumberToFixed(
            parseNumericValue(employeePayBenefits?.basic_salary)
          )}
        </Typography> */}
         
        
        {/* <Typography
          variant="body2"
          color="primary"
          colorVariant="light"
          fontWeight={500}
        >C
          
          Employee Total Deduction = {formatNumberToFixed(totalDeduction)}
        </Typography> */}


        {/* <Typography
          variant="body2"
          color="primary"
          colorVariant="light"
          fontWeight={500}
        >
         
          Net Payble = {" "}
          {formatNumberToFixed(
            parseNumericValue(grossAmount) - parseNumericValue(totalDeduction)
          )} 
         (Round off: {Math.ceil(Number(formatNumberToFixed(
            parseNumericValue(grossAmount) - parseNumericValue(totalDeduction)
          )))})
        </Typography> */}
       
      </Box>
      {/* <Typography variant="body2" color="default" colorVariant="light">
        The breakup of salary will be:
      </Typography>
      <Divider gap={15} /> */}
      <Box>
        
        </Box>
    </Dialog>
  );
};

export default SalaryDetailsView;
